import React from 'react';
import PropTypes from 'prop-types';

import { STATIC_CMS_ROOT } from '../../constants';
import { getMerchantCardUrl } from '../../services/partner/utils';

import LocalizedNavLink from '../router/LocalizedNavLink';
import PartnerBlockComponent from '../partner/PartnerBlockComponent';

class ItemCarrouselComponent extends React.Component {
    renderPicture() {
        const { partner, item, noPicture } = this.props;

        if (noPicture) return null;

        return (
            <picture>
                <source
                    srcSet={`${STATIC_CMS_ROOT}/carousel/${item.image2}`}
                    media="(max-width: 768px)"
                />
                <img
                    src={`${STATIC_CMS_ROOT}/carousel/${item.image}`}
                    alt={partner ? partner.name : ''}
                />
            </picture>
        );
    }

    renderContionnalPictureContainer = () => {
        const { partner, item } = this.props;

        if (!partner) {
            const urlMea = item.tracking;

            if (urlMea) {
                return <a href={urlMea}>{this.renderPicture(item, partner)}</a>;
            } else {
                return this.renderPicture(item, partner);
            }
        } else {
            const urlMea = getMerchantCardUrl(partner, false, item.ebon);

            return (
                <LocalizedNavLink to={urlMea}>{this.renderPicture(item, partner)}</LocalizedNavLink>
            );
        }
    };

    render() {
        const { partner, item, isOffline, isEbon } = this.props;

        if (!item) {
            return null;
        }

        return (
            <div className="item">
                {this.renderContionnalPictureContainer()}
                {partner && (
                    <PartnerBlockComponent
                        partner={partner}
                        isOffline={isOffline}
                        isEbon={isEbon}
                    />
                )}
            </div>
        );
    }
}

ItemCarrouselComponent.propTypes = {
    item: PropTypes.object.isRequired,
    partner: PropTypes.object,
    noPicture: PropTypes.bool,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool
};

export default ItemCarrouselComponent;



// WEBPACK FOOTER //
// ./src/components/carousel/ItemCarrouselComponent.js